import { Project } from '../lead-generation/shared/models/Project';

import { createSelector } from 'reselect';
import {
  GET_REPORTS_META_DATA_SUCCESS,
  GET_OVERALL_REPORTS_META_DATA_SUCCESS,
  GET_PROJECTS_SUCCESS,
  ReportsAction
} from './reports.actions';
import { ReportMetaData } from './report';

export interface ReportsState {
  projects: Project[];
  metaData: ReportMetaData;
  overallMetaData: ReportMetaData;
}

export const initialState: ReportsState = { projects: [], metaData: null, overallMetaData: null };

export function reportsReducer(state: ReportsState = initialState, action: ReportsAction): ReportsState {
  switch (action.type) {
    case GET_PROJECTS_SUCCESS:
      const projects: Project[] = action.payload.map(({ id, name, status }) => ({ id, name, status }));
      return { ...state, projects: projects };
    case GET_REPORTS_META_DATA_SUCCESS:
      return { ...state, metaData: action.payload };
    case GET_OVERALL_REPORTS_META_DATA_SUCCESS:
      return { ...state, overallMetaData: action.payload };
    default: {
      return state;
    }
  }
}

const getProjects = (reportState: ReportsState): Project[] => reportState.projects;
const getMetaData = (reportState: ReportsState): ReportMetaData => reportState.metaData;
const getOverallMetaData = (reportState: ReportsState): ReportMetaData => reportState.overallMetaData;

export const getMainReportsSelector = (state): ReportsState => state.reports;

export const getProjectsSelector = createSelector(getMainReportsSelector, getProjects);
export const getMetaDataSelector = createSelector(getMainReportsSelector, getMetaData);
export const getOverallMetaDataSelector = createSelector(getMainReportsSelector, getOverallMetaData);
